module.exports = __webpack_public_path__ + "static/media/410GriffinStNW_2018-06-05_42.58d5fcb0.jpg";